import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "fixed z-40 px-12 py-8 bg-white rounded-lg absolute-center dark:bg-gray-800 shadow-200 dark:border dark:border-gray-900"
};
const _hoisted_2 = { class: "pb-8 text-2xl font-bold text-primary-900 dark:text-gray-300" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.topics.sharing')
};
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { gsap } from 'gsap';
import { useRetroStore } from '@/pinia_stores/retro';
import constants from '@/constants';
import Topic from '@/components/topics/Topic.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'TopicBeingShared',
    setup(__props) {
        const retroStore = useRetroStore();
        const { isOtherUserSharing, topicBeingShared, users } = storeToRefs(retroStore);
        const userName = computed(() => users.value.find((u) => u.id === topicBeingShared.value.userId)?.name ?? '');
        function enter(el, done) {
            gsap.from(el, {
                duration: constants.SPEED.normal,
                autoAlpha: 0,
                y: '100%',
                ease: 'back.out',
                onComplete: done
            });
        }
        function leave(el, done) {
            gsap.to(el, { duration: constants.SPEED.fastest, autoAlpha: 0, onComplete: done });
        }
        return (_ctx, _cache) => {
            const _component_transition_a11y = _resolveComponent("transition-a11y");
            return (_openBlock(), _createBlock(_component_transition_a11y, {
                css: false,
                onEnter: enter,
                onLeave: leave
            }, {
                default: _withCtx(() => [
                    (_unref(isOtherUserSharing))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(userName)) + " " + _toDisplayString(_ctx.$t('wrote')) + "... ", 1),
                            _createVNode(Topic, {
                                topic: _unref(topicBeingShared),
                                class: "w-76"
                            }, null, 8, ["topic"])
                        ]))
                        : _createCommentVNode("", true)
                ], undefined, true),
                _: 1
            }));
        };
    }
});
